import { ReactElement, Suspense, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { getUserDetails } from 'config/authConfig';
import CenteredLoadingDisplay from 'components/CenteredLoadingDisplay/CenteredLoadingDisplay';
import ProjectPage from '../../pages/Projects/ProjectsPage';
import ProjectDashboard from '../../pages/ProjectDashboard/ProjectDashboard';
import CalculationPage from 'pages/Calculation/CalculationPage';
import { NotFoundPage } from 'pages/NotFound/NotFoundPage';
import { CalculationContextProvider } from 'pages/Calculation/CalculationContextProvider';
import { Division, UserDetails } from 'types/domainTypes';

function App(): ReactElement {
  const [user, setUser] = useState<UserDetails>();

  useEffect(() => {
    async function fetchUserDetails() {
      const userDetails: UserDetails = await getUserDetails();
      setUser(userDetails);
    }

    if (!user) {
      fetchUserDetails();
    }
  }, [user]);

  if (!user) return <CenteredLoadingDisplay />;

  return (
    <Suspense fallback="Loading...">
      <Router>
        <Routes>
          <Route path={`/${Division.Kingspan}`} element={<ProjectPage division={Division.Kingspan} user={user} />} />
          <Route path={`/${Division.Joriside}`} element={<ProjectPage division={Division.Joriside} user={user} />} />
          <Route path="/project/:projectId" element={<ProjectDashboard />} />
          <Route
            path="/project/:projectId/calculation/:calculationId"
            element={
              <CalculationContextProvider>
                <CalculationPage />
              </CalculationContextProvider>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </Suspense>
  );
}

export default App;
